import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'
import CurriculumLayout from '../../components/layout/CurriculumLayout'
import PromoCodesBox from '../../components/admin/PromoCodesBox'

const PromoCodes = () => {
  return (
    <AdminLayout>
      <AdminContentLayout>
        <CurriculumLayout title={'Promo Codes'}>
          <PromoCodesBox />
        </CurriculumLayout>
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default PromoCodes
